<app-youtube-navbar></app-youtube-navbar>
<!-- START: Main content -->
<div class="d-flex mt-4 gap-4">
  <!-- START: Video section -->
  <div class="d-flex flex-column gap-2">
    <!-- START: Video playback placeholder -->
    <img
      class="yt-playback-image"
      src="/assets/images/youtube-placeholder-playback.png"
      alt=""
    />
    <!-- End: Video playback placeholder -->

    <!-- START: Video info -->
    <div class="yt-heading-description">
      <p class="placeholder">This is the video heading placeholder</p>
      <p class="placeholder">
        This is video description placeholder, it is much longer!
      </p>
    </div>
    <div class="yt-icon placeholder"></div>
    <div class="yt-comments">
      <span class="fs-6 placeholder">
        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
      </span>
      <span class="fs-6 placeholder">
        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
      </span>
      <span class="fs-6 placeholder">
        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
      </span>
      <span class="fs-6 placeholder">
        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
      </span>
    </div>
    <!-- END: Video info -->
  </div>
  <!-- END: Video section -->

  <!-- START: Content -->
  <div class="">
    <div class="yt-videos d-flex gap-3 flex-wrap">
      <!-- START: Real ad -->
      <div class="yt-video-row d-flex flex-row gap-3">
        <img *ngIf="creativeImage" class="yt-ad-image yt-ad-creative" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="yt-ad-image yt-ad-creative creative-missing">{{ missingDimensionLabel }}</div>
        <div class="yt-video-info">
          <h4 class="yt-title">{{ data.headlines[0] }}</h4>
          <div class="yt-meta">{{ data.descriptions[0] }}</div>
          <div class="yt-meta">
            <span class="yt-sponsored"><strong>Sponsored</strong></span> •
            Valamar
          </div>
          <button type="button" class="btn btn-primary yt-ad-cta mt-4">
            <span class="fw-bolder">{{ data.ctaText }}</span>
            <i class="ml-1 bi bi-box-arrow-up-right"></i>
          </button>
        </div>
      </div>
      <!-- END: Real ad -->

      <!-- START: Video placeholder -->
      <div class="yt-video-row d-flex flex-row gap-2">
        <img
          class="yt-ad-image"
          src="/assets/images/youtube-placeholder-video.png"
          alt=""
        />
        <div class="d-flex flex-column gap-2">
          <div class="yt-video-info">
            <span class="yt-title placeholder"
              >This is placeholder headline</span
            >
          </div>
          <div class="yt-video-info">
            <span class="yt-title placeholder">This is placeholder</span>
          </div>
        </div>
      </div>
      <!-- END: Video placeholder -->

      <!-- START: Video placeholder -->
      <div class="yt-video-row d-flex flex-row gap-2">
        <img
          class="yt-ad-image"
          src="/assets/images/youtube-placeholder-video.png"
          alt=""
        />
        <div class="d-flex flex-column gap-2">
          <div class="yt-video-info">
            <span class="yt-title placeholder"
              >This is placeholder headline</span
            >
          </div>
          <div class="yt-video-info">
            <span class="yt-title placeholder">This is placeholder</span>
          </div>
        </div>
      </div>
      <!-- END: Video placeholder -->

      <!-- START: Video placeholder -->
      <div class="yt-video-row d-flex flex-row gap-2">
        <img
          class="yt-ad-image"
          src="/assets/images/youtube-placeholder-video.png"
          alt=""
        />
        <div class="d-flex flex-column gap-2">
          <div class="yt-video-info">
            <span class="yt-title placeholder"
              >This is placeholder headline</span
            >
          </div>
          <div class="yt-video-info">
            <span class="yt-title placeholder">This is placeholder</span>
          </div>
        </div>
      </div>
      <!-- END: Video placeholder -->
    </div>
  </div>
  <!-- End: Content -->
</div>
<!-- END: Main content -->
